import _ from 'lodash';
import {
  DefinitionLevels,
  ORG_SIZE_METRICS_BENCHMARKS,
  metricsScales,
  BENCHMARK_ORG_SIZE_KEYS
} from '@linearb/linjs-common';
import { SETTING_NAMES } from 'common/constants/constants';

const ENGINEERING_METRICS_BENCHMARKS_URL =
  'https://linearb.io/engineering-benchmarks/';

export const isDisplayBenchmark = ({
  getSettingOrDefinitionValue,
  selectedTeamId
}) => {
  const metricsBenchmarksEnabledOrgLevel = getSettingOrDefinitionValue({
    name: SETTING_NAMES.METRICS_BENCHMARKS_ENABLED,
    definitionLevel: DefinitionLevels.ORGANIZATION
  });

  const metricsBenchmarksEnabled = selectedTeamId
    ? getSettingOrDefinitionValue({
        name: SETTING_NAMES.METRICS_BENCHMARKS_ENABLED,
        definitionLevel: DefinitionLevels.TEAM,
        teamId: selectedTeamId
      })
    : metricsBenchmarksEnabledOrgLevel;

  return metricsBenchmarksEnabledOrgLevel && metricsBenchmarksEnabled;
};

export const getRangeIndex = ({
  value,
  ranges,
  granularity,
  benchmarkGranularity,
  benchmarkScale
}) => {
  let calculatedBenchmarkValue = value;
  const shouldConvertBenchmarkGranularity =
    benchmarkScale === metricsScales.FREQUENCY &&
    benchmarkGranularity &&
    granularity &&
    benchmarkGranularity !== granularity;
  if (shouldConvertBenchmarkGranularity) {
    calculatedBenchmarkValue = convertValueForBenchmarks(
      benchmarkGranularity,
      granularity,
      calculatedBenchmarkValue
    );
  }
  calculatedBenchmarkValue = Math.floor(calculatedBenchmarkValue);
  return ranges.findIndex(
    ({ min_value: minValue, max_value: maxValue }) =>
      (!minValue && calculatedBenchmarkValue < maxValue) ||
      (!maxValue && calculatedBenchmarkValue >= minValue) ||
      (maxValue &&
        minValue &&
        minValue <= calculatedBenchmarkValue &&
        calculatedBenchmarkValue < maxValue)
  );
};

const convertValueForBenchmarks = (
  benchmarkGranularity,
  granularity,
  value
) => {
  if (benchmarkGranularity === 'week') {
    switch (granularity) {
      case 'month':
        return value / 4;
      case 'day':
        return value * 7;
      default:
        return value;
    }
  }
  return value;
};

export const getBenchmarkByAggAndOrgSize = ({
  benchmark,
  metricsCalculationStrategy = 'avg',
  benchmarkOrgSize = BENCHMARK_ORG_SIZE_KEYS.all,
  isCycletimeMetrics = false
}) => {
  const rangesByOrgSize = _.get(
    benchmark,
    benchmarkOrgSize,
    _.get(benchmark, BENCHMARK_ORG_SIZE_KEYS.all, [])
  );

  const rangesByAgg = _.get(rangesByOrgSize, metricsCalculationStrategy);

  if (isCycletimeMetrics) {
    return rangesByAgg;
  }

  const metricsRanges = rangesByAgg || _.get(rangesByOrgSize, 'default', []);

  const updatedMetricsRanges = metricsRanges.map(item =>
    item.title === 'STRONG' ? { ...item, title: 'GOOD' } : item
  );

  return updatedMetricsRanges;
};

export const getBenchmarkRange = ({
  value,
  metricName,
  metricsCalculationStrategy = 'avg',
  granularity = null,
  benchmarkOrgSize = BENCHMARK_ORG_SIZE_KEYS.all
}) => {
  const benchmark = ORG_SIZE_METRICS_BENCHMARKS[metricName];
  if (!benchmark) {
    return null;
  }

  const ranges = getBenchmarkByAggAndOrgSize({
    benchmark,
    metricsCalculationStrategy,
    benchmarkOrgSize
  });

  if (!ranges.length) {
    return null;
  }

  const rangeIndex = getRangeIndex({
    value,
    ranges,
    granularity,
    benchmarkGranularity: benchmark.granularity,
    benchmarkScale: benchmark.scale
  });

  return _.get(ranges, `[${rangeIndex}]`);
};

/* istanbul ignore next */
export const openEngineeringMetricsBenchmarks = () => {
  window.open(ENGINEERING_METRICS_BENCHMARKS_URL);
};
